import classNames from 'classnames';
import styles from './ThreatIcon.module.scss';
import { Tooltip } from '@/shared/ui/Tooltip';
import WalletIcon from '@/assets/icons/wallet.svg?react';
import PhishingIcon from '@/assets/icons/fishing.svg?react';
import LeaksIcon from '@/assets/icons/leak.svg?react';
import CopyrightIcon from '@/assets/icons/copyright.svg?react';
import InformationIcon from '@/assets/icons/book.svg?react';

export type ThreatType = 'scam' | 'phishing' | 'leaks' | 'copyright' | 'information' | 'mention' | 'domain_squatting';

export interface ThreatIconProps {
  type: ThreatType;
  className?: string;
  showTooltip?: boolean;
}

const threatTypeDescriptions: Record<ThreatType, string> = {
  scam: 'Мошенничество',
  phishing: 'Фишинг',
  leaks: 'Утечка',
  copyright: 'Авторское право',
  information: 'Информация',
  mention: 'Упоминание',
  domain_squatting: 'Доменный сквоттинг',
};

const getThreatIcon = (type: ThreatType): React.ReactNode => {
  switch(type) {
    case 'scam':
      return <WalletIcon />;
    case 'phishing':
      return <PhishingIcon />;
    case 'leaks':
      return <LeaksIcon />;
    case 'copyright':
      return <CopyrightIcon />;
    case 'information':
      return <InformationIcon />;
    default:
      return <InformationIcon />;
  }
};

export const ThreatIcon = ({ type, className, showTooltip = true }: ThreatIconProps) => {
  const iconElement = (
    <div className={classNames(styles['threat-icon'], styles[type], className)}>
      {getThreatIcon(type)}
    </div>
  );

  if (showTooltip) {
    return (
      <Tooltip content={threatTypeDescriptions[type]}>
        {iconElement}
      </Tooltip>
    );
  }

  return iconElement;
};

